import BaseParser from './BaseParser';

export type PrimitiveType =
  | fhir.instant
  | fhir.time
  | fhir.date
  | boolean
  | fhir.uri
  | fhir.oid
  | fhir.markdown
  | fhir.code
  | string
  | fhir.base64Binary
  | fhir.positiveInt
  | fhir.unsignedInt
  | fhir.integer
  | fhir.decimal;

// will be extended in the future
class Primitive extends BaseParser {
  getSortValue(fhirProperty: PrimitiveType) {
    return (fhirProperty === undefined ? null : fhirProperty) as
      | string
      | number;
  }
}

export default Primitive;
